import { policyType as PolicyType } from '@ourbranch/lookups';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';

/**
 * Whether the "last inspection date" field (#33158) should be surfaced for a policy of this
 * type. Inspections are a property concept, so the field is shown for every product EXCEPT
 * monoline auto. Bundles that include a property line (Home+Auto, Auto+Renters, Condo+Auto)
 * still carry a property component, so they show it too.
 */
export const showsLastInspectionField = (policyType) => Boolean(policyType) && policyType !== PolicyType.Auto;

export const getPolicyType = (policyType, noBindHome = false, noBindAuto = false) => {
  const hasHome = (policyType === PolicyType.HABundle && !noBindHome) || policyType === PolicyType.Home;
  const hasAuto =
    (policyType === PolicyType.HABundle && !noBindAuto) ||
    policyType === PolicyType.Auto ||
    policyType === PolicyType.ARBundle ||
    policyType === PolicyType.CABundle;
  const hasCondo = [PolicyType.Condo, PolicyType.CABundle].includes(policyType);
  const hasFarm = isFarmBasedPolicyType(policyType);

  const isHomeBundle = policyType === PolicyType.HABundle && !noBindHome && !noBindAuto;
  const isCondoBundle = policyType === PolicyType.CABundle;
  const isRenters = policyType === PolicyType.ARBundle || policyType === PolicyType.Renters;
  const isHome = policyType === PolicyType.Home;
  const isAuto = policyType === PolicyType.Auto;
  const isCondo = policyType === PolicyType.Condo;
  const isAnyBundle = isHomeBundle || isCondoBundle || isRenters;

  return {
    hasHome,
    hasAuto,
    isHomeBundle,
    isCondoBundle,
    isCondo,
    hasCondo,
    isRenters,
    isHome,
    isAuto,
    isAnyBundle,
    hasFarm
  };
};
